// extracted by mini-css-extract-plugin
export default {"bg-primary-dark":"Button_bg-primary-dark__Tnu80","bg-primary-light":"Button_bg-primary-light__VA5+z","root":"Button_root__O9eWO"};